var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * BeoPassword is custom made Password component.
 *
 * @author rajeev.k
 * @description This component is an extension of PrimeReact Password tag (<Password/>).
 * All properties of PrimeReact Password can be used by this BeoPassword component.
 */
import { Password } from "primereact/password";
var BeoPassword = function (_a) {
    var id = _a.id, ref = _a.ref, props = __rest(_a, ["id", "ref"]);
    return _jsx(Password, __assign({ id: id, ref: ref }, props));
};
export default BeoPassword;
